import React from 'react';
import { LegalPage } from '@/components/legal';

export function Privacy() {
  return (
    <LegalPage
      documentType="privacy"
      title="Privacy Policy"
      accentColor="green"
    />
  );
}
